<template>
  <!-- The site's copy glyph — two stacked squares — shared by every Copy
       action (swatch cards, logo cards) so they read as the same action.
       Sized by the caller. -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="currentColor" aria-hidden="true">
    <rect y="2.35276" width="7.64724" height="7.64724" rx="1.5" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.38144 1.20525C2.4768 1.18623 2.57543 1.17626 2.67638 1.17626H7.32362C8.15205 1.17626 8.82362 1.84783 8.82362 2.67626V7.3235C8.82362 7.4243 8.81368 7.52278 8.79472 7.61801C9.48191 7.481 9.99978 6.87448 9.99978 6.147V1.49976C9.99978 0.671333 9.32821 -0.000240326 8.49978 -0.000240326H3.85254C3.12491 -0.000240326 2.51829 0.517842 2.38144 1.20525Z" />
  </svg>
</template>
